var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 86,
    viewBox: "0 0 158 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251102",
    d: "M117 73L157 73",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234251103",
    d: "M1 73L32.9392 73",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250842",
    d: "M56.6259 29.875L46.1253 33.3752M74.127 47.5V85.0035M104.754 33.3752L91.6281 29.875M74.127 85.0035L106.504 72.7527V47.6678M74.127 85.0035L41.75 72.7527V50.1042",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250843",
    d: "M32.5 46.0008L45.6258 32.875L74.1268 46.5013L105 33.0027L117.251 42.6283L106.504 47.668L85.5026 57.0019L74.1268 46.5013L62.7511 58.752L41.7498 50.1044L32.5 46.0008Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250841",
    d: "M39.125 1H66.2521C70.1181 1 73.2521 4.13401 73.2521 8V29.0018M73.2521 29.0018L80.2526 22.8764M73.2521 29.0018L64.5016 22.8764",
    stroke: "#383434",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPacked);
export default __webpack_public_path__ + "static/media/orderPacked.ccea5fcd752fef39911934e386c9b651.svg";
export { ForwardRef as ReactComponent };